import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { IoMdArrowDropdown } from 'react-icons/io';
import Portal from '@reach/portal';
import AnimateHeight from 'react-animate-height';
import { NGroups } from './styles';
import Link from '../../elements/Link/Link';
import Expander from '../Expander/Expander';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SubNav = _ref => {
  let {
    parentPath,
    sub,
    onLinkClick
  } = _ref;
  return ___EmotionJSX("ul", {
    className: "subnav"
  }, sub.map(subpage => {
    let subroute;
    if (subpage.external_path) {
      subroute = subpage.external_path;
    } else {
      if (subpage.path_prefix) {
        subroute = `/${parentPath}/${subpage.path}`;
      } else {
        subroute = `/${subpage.path}`;
      }
    }
    return ___EmotionJSX("li", {
      key: subpage.display_name
    }, ___EmotionJSX(Link, {
      activeClassName: 'current',
      className: subpage.type ? subpage.type : null,
      to: subroute,
      anchor: subpage.anchor,
      onClick: onLinkClick
    }, subpage.display_name));
  }));
};
const Groups = _ref2 => {
  let {
    parentPath,
    groups,
    isOpen,
    onLinkClick,
    renderGroupsInPortal
  } = _ref2;
  if (renderGroupsInPortal) {
    return ___EmotionJSX(Portal, null, ___EmotionJSX(AnimateHeight, {
      duration: 200,
      height: isOpen ? 'auto' : 0,
      style: {
        position: 'absolute',
        top: '170px',
        left: 0,
        right: 0,
        zIndex: 1
      }
    }, ___EmotionJSX(NGroups, {
      className: "int-groups",
      visible: isOpen
    }, groups.map(group => ___EmotionJSX("div", {
      key: group.display_name,
      className: "int-group"
    }, ___EmotionJSX("p", null, group.display_name), ___EmotionJSX(SubNav, {
      parentPath: parentPath,
      sub: group.sub,
      onLinkClick: onLinkClick
    }))))));
  } else {
    return ___EmotionJSX(AnimateHeight, {
      duration: 200,
      height: isOpen ? 'auto' : 0
    }, ___EmotionJSX("div", {
      className: "int-groups-inline"
    }, groups.map(group => ___EmotionJSX("div", {
      key: group.display_name,
      className: "int-group-inline"
    }, renderGroupsInPortal && ___EmotionJSX("p", null, group.display_name), ___EmotionJSX(Expander, {
      title: group.display_name,
      close: !isOpen
    }, ___EmotionJSX(SubNav, {
      sub: group.sub,
      onLinkClick: onLinkClick
    }))))));
  }
};
const NewMenuStructure = _ref3 => {
  let {
    menu,
    renderGroupsInPortal
  } = _ref3;
  const {
    0: groupOpen,
    1: setGroupOpen
  } = useState({
    open: {}
  });
  const toggleGroup = i => {
    setGroupOpen(prevState => {
      const open = _objectSpread({}, prevState.open);
      Object.keys(open).forEach(v => {
        v = parseInt(v);
        if (v !== i) {
          delete open[v];
        }
      });
      open[i] = !open[i];
      return {
        open
      };
    });
  };
  const closeGroups = () => {
    const open = _objectSpread({}, groupOpen);
    Object.keys(open).forEach(v => {
      v = parseInt(v);
      return open[v] = false;
    });
    setGroupOpen({
      open: open
    });
  };
  const Chevron = _ref4 => {
    let {
      direction
    } = _ref4;
    if (direction === 'up') {
      return ___EmotionJSX(FaChevronUp, null);
    } else {
      return ___EmotionJSX(FaChevronDown, null);
    }
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("ul", null, menu.map((page, i) => {
    const hasGroup = page.groups && page.groups.length > 0;
    let path;
    if (page.path === '') {
      path = '/';
    }
    if (page.external_path) {
      path = page.external_path;
    } else {
      if (page.path !== '/') {
        path = '/' + page.path;
      }
    }
    return ___EmotionJSX("li", {
      key: page.display_name
    }, hasGroup ? ___EmotionJSX("button", {
      style: {
        cursor: 'pointer'
      },
      className: groupOpen.open[i] ? 'active' : '',
      onClick: () => toggleGroup(i)
    }, page.display_name, " ", ___EmotionJSX(Chevron, {
      direction: groupOpen.open[i] ? 'up' : 'down'
    })) : ___EmotionJSX(Link, {
      activeClassName: 'current',
      anchor: page.anchor,
      className: page.type ? page.type : null,
      to: path,
      partiallyActive: path !== '/',
      onClick: closeGroups
    }, page.display_name, " ", page.sub && ___EmotionJSX(IoMdArrowDropdown, null)), page.sub && ___EmotionJSX(SubNav, {
      parentPath: page.path,
      sub: page.sub,
      onLinkClick: closeGroups
    }), page.groups && ___EmotionJSX(Groups, {
      parentPath: page.path,
      groups: page.groups,
      isOpen: groupOpen.open[i],
      renderGroupsInPortal: renderGroupsInPortal,
      onLinkClick: closeGroups
    }));
  })));
};
NewMenuStructure.defaultProps = {
  renderGroupsInPortal: true
};
export default NewMenuStructure;